module.exports = __webpack_public_path__ + "img/dls-logo.fb5e89d0.png";